import React from 'react';
import $ from 'jquery';
import _ from 'lodash';

import UnitFilter from './unitFilterComponent';
import NoResults from './../no_results/noResultsComponent';

import { hasClassification } from './../../mixin/mixin';

class Units extends React.Component {
  constructor() {
    super();

    this._hasClassification = hasClassification;
  }

  render() {
    let units = this.props.data.units; //this.filterUnits(this.props.data.units);
    let lightboxType = this.props.lightboxType;
    let redirectLink = '';
    let linkDestination,
        linkText;
    if(lightboxType == "Degrees"){
      linkDestination = this.props.options.url_discipline_page;
      linkText = 'Change path to mix & match units from across degrees';
      var pathName = this.props.hasOwnProperty('classification') && this.props.classification.length > 0 ? this.props.classification : 'Critical Content ';
      var description = '';
      if (pathName == 'Advanced') {
        description =
          (<p>Select 2, 3 or 4 units to create an
            <strong>
              {this.props.hasOwnProperty('classification') && this.props.classification.length > 0 ?
                ' ' + this.props.classification + ' ' : ' Critical Content '}
            </strong>
            Bespoke Course in <strong>{this.props.heading}</strong>.
            {' ' + this.props.options.lightbox_description}
          </p>);
      } else {
        description =
          (<p>Select 2, 3 or 4 units to create a
            <strong>
              {this.props.hasOwnProperty('classification') && this.props.classification.length > 0 ?
                ' ' + this.props.classification + ' ' : ' Critical Content '}
            </strong>
            Bespoke Course in <strong>{this.props.heading}</strong>.
            {' ' + this.props.options.lightbox_description}
          </p>);
      }
    }else if(lightboxType == "Disciplines") {
      linkDestination = this.props.options.url_degree_default_page;
      linkText = 'Change path to select units that align to a traditional degree';
      var description =
        (<p>
          Select any 2, 3 or 4 units to create a Bespoke Course.
        </p>);
    }

    return <div>
        <UnitFilter classification={this.props.classification}
          handleClickFilter={this.props.handleClickFilter} />

        <div className="units-cat__content">
          <div className="units-cat__desc">
            {description}
          </div>
          <div className="units__wrap">
            <ul className="units__list">
              {units.length > 0 ? units.map(function(item, i) {
                return this.props.createUnit(item, i, this._hasClassification(item.Classification, this.props.classification)); }, this)
                : <NoResults msg={'No <strong>' +
                  this.props.classification +
                  '</strong> units are found.'} />
              }
            </ul>
          </div>
          <div className="sq-form-control clearfix">
            <a href={linkDestination} className="button type-2 btn-reset">{linkText}</a>
          </div>
      </div>
    </div>;
  }

  filterUnits(units = []) {
    let newUnits = [];

    for (let i = 0, len = units.length; i < len; i++) {
      let item = units[i];

      // Need to change to lowercase property later (!important)
      if (this._hasClassification(item.Classification, this.props.classification)) {
        newUnits.push(item);
      }
    }

    return newUnits;
  }

}

Units.propTypes = {
  data:              React.PropTypes.object.isRequired,
  options:           React.PropTypes.object.isRequired,
  heading:           React.PropTypes.string.isRequired,
  classification:    React.PropTypes.string.isRequired,
  comparedUnits:     React.PropTypes.array.isRequired,
  handleClickFilter: React.PropTypes.func.isRequired,
  createUnit:        React.PropTypes.func.isRequired
};

export default Units;
